export * from './apps.service'
import { AppsService } from './apps.service'
export const APIS = [AppsService]
